import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/70 px-3 py-1 rounded-full mb-3">
            期待你的声音
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">联系我们</h2>
          <p className="text-sm text-foreground-600 mt-2">{contactInfo.desc}</p>
        </div>

        <div className="bg-background-100 border border-background-200/70 rounded-2xl p-6 md:p-8">
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10">
            <div className="flex items-center gap-3 px-6 py-4 bg-background-50 rounded-xl border border-background-200/70">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center shrink-0">
                <i className="ri-mail-line text-lg text-accent-500"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-400">投稿与合作邮箱</p>
                <p className="text-sm font-semibold text-foreground-900">{contactInfo.email}</p>
              </div>
            </div>

            <div className="flex-1">
              <ul className="space-y-2">
                {contactInfo.tips.map((tip, i) => (
                  <li key={i} className="flex items-start gap-2 text-sm text-foreground-600">
                    <i className="ri-check-line text-accent-500 text-sm mt-0.5 shrink-0"></i>
                    <span>{tip}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}